export const RoundCheckMarkGrey = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="9" cy="9" r="9" fill="#43474A" />
      <path
        d="M5 8.94545L7.84444 12L13 6"
        stroke="#AEAEAE"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
